module.exports = __webpack_public_path__ + "assets/img/bg.934940ff.svg";